import React from "react";
import { Link } from "react-router-dom";

const ReportStatCard = ({
  title,
  value,
  subtitle,
  error,
  to,
}) => {
  const card = (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <p className="text-muted mb-2 small">{title}</p>

            <h4 className={`fw-bold mb-1`}>{value}</h4>

            {error && <p className="text-danger">{error}</p>}

            {subtitle && <small className="text-muted">{subtitle}</small>}
          </div>
        </div>
      </div>
    </div>
  );

  if (to) {
    return (
      <Link to={to} className="col-xl-3 col-lg-4 col-md-6 mb-4 text-decoration-none">
        {card}
      </Link>
    );
  }

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
      {card}
    </div>
  );
};

export default ReportStatCard;
